import React from 'react'

import type {AppConfig} from '../types'

const AppConfigContext = React.createContext<AppConfig | null>(null)

export const useAppConfigContext = () => {
  const context = React.useContext(AppConfigContext)

  if (context === null) {
    throw new Error('useAppConfig must be used within a AppConfigProvider')
  }

  return context
}

type Context = React.PropsWithChildren<{
  value: AppConfig
}>

const AppConfigProvider: React.FC<Context> = ({children, value}) => {
  return (
    <AppConfigContext.Provider value={value}>
      {children}
    </AppConfigContext.Provider>
  )
}

AppConfigProvider.displayName = 'AppConfigContext'

export default AppConfigProvider
